import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d08ecb5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ib-tooltip" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { autoGenerateColumns } from '@progress/kendo-vue-grid';
import { Tooltip } from '@progress/kendo-vue-tooltip';


export default /*#__PURE__*/_defineComponent({
  __name: 'IBTooltip',
  props: {
  width: {
    type: [String, Number],
    default: 'auto'
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createBlock(_unref(Tooltip), {
    content: 'tooltipTemplate',
    position: "top",
    "anchor-element": 'target',
    openDelay: 0,
    showCallout: false,
    className: "ib-tooltip-wrapper",
    wrapperStyle: {
      backgroundColor:'var(--white)',
      border: '1px solid var(--primary)',
      borderRadius: '4px',
      width: props.width
    },
    tooltipStyle: {
        backgroundColor: 'transparent',
        border: 'none',
    }
  }, {
    tooltipTemplate: _withCtx(({ props }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_i18n_t, {
          tag: "span",
          keypath: props.title
        }, {
          newline: _withCtx(() => [
            _hoisted_2
          ]),
          _: 2
        }, 1032, ["keypath"])
      ])
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["wrapperStyle"]))
}
}

})